module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-4.3e408b9c.mp3";